export const edproFaqAccordion = function() {
    $(".faq__title").on("click", function(e) {

        e.preventDefault();
        var $this = $(this);

        if (!$this.hasClass("faq-active")) {
            $(".faq__content").slideUp(400);
            $(".faq__title").removeClass("faq-active");
            $('.faq__arrow').removeClass('faq__rotate');
        }

        $this.toggleClass("faq-active");
        $this.next().slideToggle();
        $('.faq__arrow',this).toggleClass('faq__rotate');
    });

}


export const edproFaqOpen = function() {
    $(".js-faq-all").on("click", function(event) {
        $(this).css('display','none').prev().addClass('open');
    });
}
